import { RmsAccountDetails } from '@/ui/features/accounts/RmsAccountDetails';
import { useAccountAuditFormatter } from '@/ui/features/accounts/hooks/useAccountAuditFormatter';
import { useAccountSlideoutAdditionalMenuItems } from '@/ui/features/accounts/hooks/useAccountSlideoutAdditionalMenuItems';
import { useSelectedPersonBackgroundCheckData } from '@/ui/hooks/useSelectedPersonBackgroundCheckData';
import { AccountsPanel } from '@juvare/contact-management/ui/features/accounts';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { RmsAccountProfileHeader } from './RmsAccountProfileHeader';

export const RmsAccountPanel = () => {
    const [searchParams] = useSearchParams();

    const id = searchParams.get('id');
    const { backgroundCheckData } = useSelectedPersonBackgroundCheckData(id ?? undefined);

    const { getAccountAdditionalMenuItems } = useAccountSlideoutAdditionalMenuItems(backgroundCheckData);
    const formatters = useAccountAuditFormatter();

    return (
        <AccountsPanel
            customAccountProfileHeaderComponent={RmsAccountProfileHeader}
            customAccountSlideoutMenuItems={getAccountAdditionalMenuItems}
            customAccountSlideoutDetailsComponent={RmsAccountDetails}
            accountEntityAuditFormatters={formatters}
        />
    );
};
